import React, { useCallback, useState } from 'react'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import AutoComplete from '@commonComponents/formComponents/AutoComplete'
import PopUpIcon from '@commonComponents/formComponents/PopUpIcon'
import { HttpClient } from '../../../commonApis/httpClient'
import { useTranslation } from '@hooks/useTranslation'


 const SearchableDropdown = ({dropdownType,...rest}) => {
  const [addList, setAddList] = useState([])
  const { isImportShipment, version, countryCode, isDisabled } = useCurrentShipmentType()
  const translate = useTranslation();
  const onSearchChange = useCallback(async (value) => {
    const data = {
        eventMessage:  {
            countryCode,
            "subSystem":version,
            "shipmentType": isImportShipment ? "IMPORT":"EXPORT",
             dropdownType,
            "searchText":value
        },
        eventType:`SEARCH_DROPDOWN_VALUES_${countryCode}`,
        eventTime: Date.now(),
      }
      const response =await HttpClient.custom({data})
      if(response.data.eventMessage[dropdownType])
            setAddList(response.data.eventMessage[dropdownType])
  }, [dropdownType,countryCode,version,isImportShipment])
  return (
    <AutoComplete
      minCharacters={2} 
      disabled={isDisabled}
      labelIcon={<PopUpIcon icon='info circle' popupText={translate('SEARCHABLE_DROPDOWN_POPUP')} />}
      {...rest}
      renderItem={({ value, text,id }) => {
        return (
          <span key={id} style={{ fontWeight: 'bold' }} className='text'>
            {`${value} ${text ? `- ${text}` :""}`}
          </span>
        )
      }}
      dataSource={addList}
      onSearchChange={onSearchChange}
    />
  )
}

export default SearchableDropdown
